import { render, staticRenderFns } from "./projectDetails.vue?vue&type=template&id=e9ee624a&scoped=true"
import script from "./projectDetails.vue?vue&type=script&lang=js"
export * from "./projectDetails.vue?vue&type=script&lang=js"
import style0 from "./projectDetails.vue?vue&type=style&index=0&id=e9ee624a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9ee624a",
  null
  
)

export default component.exports